<p>Hola, {{ name }} 👋</p>
<p>Este contenido fue inyectado dinámicamente.</p>